import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Chip,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { ExpandMore, Person, PersonRemove } from "@mui/icons-material";
import type { ClubMember } from "./types";

interface ClubMembersSectionProps {
  members: ClubMember[];
  onRemove: (member: ClubMember) => void;
}

const ClubMembersSection: React.FC<ClubMembersSectionProps> = ({
  members,
  onRemove,
}) => {
  const theme = useTheme();

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          bgcolor: theme.palette.primary.light + "10",
          borderRadius: 1,
          mb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Person />
          <Typography sx={{ fontWeight: 600 }}>
            Club Members ({members?.length})
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ px: { xs: 1, sm: 2 }, pt: 1.5, pb: 2 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {members?.map((member) => (
            <Tooltip key={member.handler_id} title={member.email_address} arrow>
              <Chip
                avatar={
                  <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                    {member.handler_name.charAt(0)}
                  </Avatar>
                }
                label={member.handler_name}
                onDelete={() => onRemove(member)}
                deleteIcon={<PersonRemove />}
                variant="outlined"
              />
            </Tooltip>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default ClubMembersSection;
